import React from "react";
import { Container } from "react-bootstrap";
import {
  SectionStyled,
  HeroBadge,
  HeroTitle,
  HeroSubtitle,
} from "./CareerPath.styles";

const CareerPathHero = () => (
  <SectionStyled>
    <Container>
      <HeroBadge>CAREER DEVELOPMENT SYSTEM</HeroBadge>
      <HeroTitle>Career Path</HeroTitle>
      <HeroSubtitle>
        From junior to principal. Track where you are, see where you're going.
      </HeroSubtitle>
    </Container>
  </SectionStyled>
);

export default CareerPathHero;
